import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

// function TabContainer(props) {
//   return (
//     <Typography component="div" style={{ padding: 8 * 3 }}>
//       {props.children}
//     </Typography>
//   );
// }

// TabContainer.propTypes = {
//   children: PropTypes.node.isRequired,
// };

const styles = theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
});


class AppBarTablet extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      value: 0,
    };
  }





  handleChange = (event, value) => {
    window.scrollTo(0, 0);
    this.setState({ value });
  };


  render() {
    const { classes, theme } = this.props;

    const { value } = this.state;

    return (
      <div className={classes.root} style={{ background: 'transparent' }}>
        <AppBar position="fixed" color="default">
          {/* <Header /> */}
          <Tabs
            // style={NavStyling.tabContainerStyle}
            value={value}
            onChange={this.handleChange}
            scrollable
            scrollButtons="on"
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab label="Home" />} />
            <Tab label="Undergraduate" />} />
            <Tab label="Graduate" />} />
            <Tab label="Projects" />} />
            <Tab label="About Me" />} />
          </Tabs>
        </AppBar>

      </div>
    );
  }

}

AppBarTablet.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(AppBarTablet);



// WEBPACK FOOTER //
// ./src/tabs/appBars/AppBarTablet.js